import { render } from "./DetailsAnnoncesView.vue?vue&type=template&id=577dd472&scoped=true"
import script from "./DetailsAnnoncesView.vue?vue&type=script&lang=js"
export * from "./DetailsAnnoncesView.vue?vue&type=script&lang=js"

import "./DetailsAnnoncesView.vue?vue&type=style&index=0&id=577dd472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577dd472"]])

export default __exports__